import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    const skip = cfg?.url?.includes("/auth/refresh") || cfg?.url?.includes("/auth/login");
    if (err.response?.status === 401 && cfg && !cfg._retry && !skip) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch (e) {}
    }
    return Promise.reject(err);
  }
);

export const formatApiError = (detail) => {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
};
